import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SocialUser } from "angularx-social-login";
import { OnboardingService } from '../onboarding.service';
declare const FB: any;
import firebase from 'firebase/app';
import 'firebase/auth'
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MixpanelService } from 'src/app/shared/service/mix-panel.service';
import { MixpanelEvent } from 'src/app/shared/model/mix-panel-event.enum';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  token: any;
  form: FormGroup;
  public user: SocialUser = new SocialUser;
  registerForm!: FormGroup;
  submitted = false;
  isCaptchaDisabled:boolean=environment.captchaDisabled;
  captchaResolved: boolean = false;
  errMessage: string = '';
  showErrMsg: boolean = false;
  @ViewChild('progressDialog', { static: true }) secondDialog: TemplateRef<any>;
  @ViewChild('appleDialog', { static: true }) appleDialog: TemplateRef<any>;
  @ViewChild('errDialog', { static: true }) errorDialog: TemplateRef<any>;
  @ViewChild('appleErrDialog', { static: true }) appleErrorDialog: TemplateRef<any>;
  readMore: boolean = false;
  firebaseLoginMethods = environment.firebaseLoginMethods;

  constructor(
    private onboardingService: OnboardingService,
    private router: Router,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private mixpanelService:MixpanelService
  ) { }
  ssoDialog: any;
  ngOnInit(): void {
    if (firebase.apps.length === 0) {
      firebase.initializeApp(environment.firebaseConfig);
    }
    // firebase.analytics();
    this.registerForm = this.fb.group({
      firstName: ['', Validators.compose([Validators.required])],
      lastName: ['', Validators.compose([Validators.required])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z0-9]{2,4}$")])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])],
      // captchaResponse: ['', Validators.compose([Validators.required])]
      captchaResponse: ['', this.isCaptchaDisabled ? null:Validators.compose([Validators.required]) ]

    });

    this.route.queryParams.subscribe(query => {
      if (query.hintkey) {
        this.registerForm.controls.emailAddress.setValue(query.hintkey);
        this.registerForm.controls.emailAddress.disable();
      }
    });
  }
  checkCaptcha(captchaResponse: string) {

    this.captchaResolved = this.isCaptchaDisabled? null:((captchaResponse && captchaResponse.length > 0) ? true : false);
  }
  get registerFormControl() {
    return this.registerForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    if (this.registerForm.valid) {
      console.log(this.registerForm.getRawValue());
      this.onboardingService.registerUser(this.registerForm.getRawValue()).subscribe((res: any) => {
        if (res) {
          console.log(res)
          this.router.navigate(['/verification'], { state: { userId: res.body.userId } })
        }
      }, err => {
        console.log(err)
        if (err === 409) {
          this.showErrMsg = true;
          this.errMessage = "A user with the same email address has already registered."
        }
      })
    }
  }

  googleSignIn() {
    this.openDialogWithoutRef()
    var CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        console.log(result)
        document.cookie = "X-Firebase-Refresh-Token=" + result.user.refreshToken + "; expires=" + CookieDate.toUTCString() + ";";
        firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ true)
          .then((idToken) => {
            console.log(idToken);
            document.cookie = "X-Firebase-Id-Token=" + idToken + "; expires=" + CookieDate.toUTCString() + ";";
            this.postUserRegistrationWithSSO(idToken,"Google");
          })
          .catch((error) => {
            this.ssoDialog.close()
            // hideLogInPopup(error, true);
          });
      }).catch((error) => {
        this.handleDifferentCredentialsError(error);
      });
  }

  facebookSignIn() {
    this.openDialogWithoutRef()
    var CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    var provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        console.log(result)
        document.cookie = "X-Firebase-Refresh-Token=" + result.user.refreshToken + "; expires=" + CookieDate.toUTCString() + ";";
        firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ true)
          .then((idToken) => {
            console.log(idToken);
            this.ssoDialog.close()
            document.cookie = "X-Firebase-Id-Token=" + idToken + "; expires=" + CookieDate.toUTCString() + ";";
            this.postUserRegistrationWithSSO(idToken,"Facebook");
          })
          .catch((error) => {
            this.ssoDialog.close()
            // hideLogInPopup(error, true);
          });
      }).catch((error) => {
        this.handleDifferentCredentialsError(error);
      });
  }

  appleSignIn() {
    this.openDialogWithoutRef();
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    const provider = new firebase.auth.OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        console.log(result);
        document.cookie =
          "X-Firebase-Refresh-Token=" +
          result.user.refreshToken +
          "; expires=" +
          CookieDate.toUTCString() +
          ";";
        if (this.isProxyEmailFromApple(result)) {
          this.dialog.closeAll();
          this.readMore = false;
          this.dialog.closeAll();
          this.dialog.open(this.appleErrorDialog);
          return;
        } else {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              document.cookie =
                "X-Firebase-Id-Token=" +
                idToken +
                "; expires=" +
                CookieDate.toUTCString() +
                ";";
              console.log(idToken);
              this.postUserRegistrationWithSSO(idToken,"Apple");
            })
            .catch(() => {
              this.dialog.closeAll();
              this.ssoDialog.close();
            });
        }
      })
      .catch((error) => {
        this.handleDifferentCredentialsError(error);
      });
  }

  isProxyEmailFromApple(result) {
    return result
      && result.additionalUserInfo
      && result.additionalUserInfo.profile?.email?.includes("privaterelay.appleid.com");
  }

  postUserRegistrationWithSSO(token, method:string) {
    var CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    this.onboardingService.ssoSignIn(token).subscribe((res) => {
      console.log(res)
      this.ssoDialog.close()
      document.cookie = "X-Firebase-Session=" + res.sessionCookie + "; expires=" + CookieDate.toUTCString() + ";";
      if (!res.isSetupVisited) {
        this.ssoDialog?.close();
        this.hideAppleInstructions();
        this.trackOnSignupCompleted(res.id,method);
        this.router.navigate([`userProfiles/${res.id}/setup/1`]).catch(console.error);
      } else {
        this.ssoDialog?.close();
        this.hideAppleInstructions();
        this.trackOnSignupCompleted(res.id,method);
        window.location.href = "/";
      }
    }, err => {
      console.log(err)
      this.ssoDialog.close()
    })
  }

  openDialogWithoutRef() {
    this.ssoDialog = this.dialog.open(this.secondDialog, { disableClose: true });
    console.log(this.ssoDialog)
  }

  showAppleInstructions() {
    this.dialog.open(this.appleDialog, { disableClose: true });
  }

  hideAppleInstructions() {
    if (this.appleDialog) {
      this.dialog.openDialogs.forEach(dialog => dialog.close())
    }
  }

  userHasEmail(additionalUserInfo) {
    return additionalUserInfo
      && additionalUserInfo.profile
      && additionalUserInfo.profile.email
      && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(additionalUserInfo.profile.email)
  }

  navigateToLogin() {
    this.router.navigate(['/login'])
  }

  onClickReadMore() {
    this.readMore = !this.readMore
  }

  handleDifferentCredentialsError(error) {
    if (error.code === "auth/account-exists-with-different-credential") {
      const email = error.email;
      let primaryPlatform = '';
      firebase
        .auth()
        .fetchSignInMethodsForEmail(email)
        .then((methods) => {
          if (methods[0] === "google.com") {
            primaryPlatform = 'Google';
            // this.googleSignIn();
          } else if (methods[0] === "facebook.com") {
            primaryPlatform = 'Facebook';
            // this.facebookSignIn();
          } else {
            primaryPlatform = 'Apple';
            // this.appleSignIn();
          }
          this.handleErrorDialog({
            message: `An account already exists with ${
              email
            } but with different social sign-in platform. Please use <strong>Continue with ${
              primaryPlatform
            }</strong> to sign in.`
          });
        })
        .catch((error) => this.handleErrorDialog(error));
    } else {
      this.handleErrorDialog(error);
    }
  }

  handleErrorDialog(error) {
    this.ssoDialog.close();
    console.log(error);
    this.errMessage = error.message;
    if (this.errMessage) {
      this.dialog.open(this.errorDialog);
    }
    setTimeout(() => {
      this.dialog.closeAll();
    }, 3000);
  }


trackOnSignupCompleted(userId:any,method:string){
  this.mixpanelService.alias(userId)
  this.mixpanelService.identifyUser(userId)
  this.mixpanelService.trackEvent({
        event:MixpanelEvent.SIGNUP_COMPLETED,
        properties:{
          customeId:method
        }
      })
}
}
